import React, {Fragment} from 'react';
import createEditor from './ComponentEditor';
import SelectorGrid from "./SelectorGrid/SelectorGrid";
import classNames from "classnames";
import {connect} from "src/store";
import {postData} from "../../utils/request";
import {showModal} from "../../actions";
import Button from "./Button";
import Icon from "./Icon";

class GroupPrivileges extends React.Component {

    state = {
        selectionPrivilegesAll: [],
        selectionPrivilegesGroup: [],
        groupPrivilegeIds: []
    }

    render() {
        const sortable = true;
        const filterable = true;
        const label = this.props.label || "Jogosultság kezelés";

        return (
            <Fragment>
                <label className="control-label">{label}</label>
                <div className="row">
                    <div className="col-md-5">
                        <SelectorGrid
                            ref={(el) => this.listAll = el}
                            disabled={this.props.disabled}
                            loading={this.props.isLoading}
                            component="Privilege"
                            view={["id","name", "label", "grant_privilege_token"]}
                            filter={this.state.groupPrivilegeIds.length ? [{field: "id", value: this.state.groupPrivilegeIds, operator: "not in"}] : []}
                            onLoadCompleted={(response) => {
                                response = {...response};
                                for (let i=0; i<response.rows.length; i++) {
                                    if (!this.props.userPrivilegesLookup.includes(response.rows[i].name)) {
                                        response.rows[i].disabled = true;
                                    }
                                }
                                return response;
                            }}
                            columns={{
                                "label": {header: 'Összes jogosultság', width: 3, sortable, filterable }
                            }}
                            rowClassName={(rowData) => {
                                const classes = {};
                                if (rowData.disabled) {
                                    classes["p-disabled"] = true;
                                }
                                return classes;
                            }}
                            pageSize={10}
                            orderBy={{field: "label", direction: "ASC"}}
                            selectionMode="multiple"
                            selection={this.state.selectionPrivilegesAll}
                            onSelectionChange={(selection) => {
                                selection.value = selection.value.filter(privilege => this.props.userPrivilegesLookup.includes(privilege.grant_privilege_token)).map((privilege) => privilege.id);
                                this.setState({selectionPrivilegesAll: selection.value});
                            }}
                        />
                    </div>
                    <div className="col-md-2">
                        <Button
                            block={true}
                            color="primary"
                            disabled={ !this.state.selectionPrivilegesAll.length || this.props.isLoading }
                            className={classNames("btn pull-left btn-primary col-sm-10", {"disabled": !this.state.selectionPrivilegesAll.length || this.props.isLoading})}
                            onClick={async () => {
                                const actionparams = {
                                    parentcomponent: "Group",
                                    listfield: "privileges",
                                    parentid: this.props.values[this.props.componentConfig.idfield],
                                    action: "componentlist.addItemsToList",
                                    items: this.state.selectionPrivilegesAll.map((item) => ({data: {Privilege_id: item}}))
                                };
                                await postData(actionparams);
                                this.setState({selectionPrivilegesAll: []});
                                this.listGroup.refresh();
                                this.listAll.refresh();
                            }}
                        >
                            <Icon lib="fa" name="arrow-right" /> Hozzáadás
                        </Button>
                        <Button
                            block={true}
                            color="primary"
                            disabled={ !this.state.selectionPrivilegesGroup.length || this.props.isLoading }
                            className={classNames("btn btn-primary col-sm-10", {"disabled": !this.state.selectionPrivilegesGroup.length || this.props.isLoading})}
                            onClick={async () => {
                                const actionparams = {
                                    parentcomponent: "Group",
                                    listfield: "privileges",
                                    parentid: this.props.values[this.props.componentConfig.idfield],
                                    action: "componentlist.removeItemsFromList",
                                    items: this.state.selectionPrivilegesGroup.map((item) => ({data: {Privilege_id: item}}))
                                };
                                await postData(actionparams);
                                this.setState({selectionPrivilegesGroup: []});
                                this.listGroup.refresh();
                                this.listAll.refresh();
                            }}
                            style={{marginTop: 20 + 'px'}}
                        >
                            Törlés <Icon lib="fa" name="arrow-left" />
                        </Button>
                    </div>
                    <div className="col-md-5">
                        <SelectorGrid
                            ref={(el) => this.listGroup = el}
                            disabled={this.props.disabled}
                            componentConfig={this.props.componentConfig}
                            listfield="privileges"
                            parentid={this.props.values[this.props.componentConfig.idfield]}
                            view={["id","name", "label", "grant_privilege_token"]}
                            aggregations={{fields: {ids: {expression: "GROUP_CONCAT(DISTINCT {{id}})"}}}}
                            onLoadCompleted={(response) => {
                                this.setState({groupPrivilegeIds: (response.aggregations?.[0]?.ids || "").split(',').filter(Boolean)});
                                for (let i=0; i<response.rows.length; i++) {
                                    if (!this.props.userPrivilegesLookup.includes(response.rows[i].grant_privilege_token)) {
                                        response.rows[i].disabled = true;
                                    }
                                }
                                return response;
                            }}
                            loading={this.props.isLoading}
                            columns={{
                                "label": {header: 'Csoport jogosultságai', width: 2, sortable, filterable }
                            }}
                            pageSize={10}
                            orderBy={{field: "label", direction: "ASC"}}
                            selectionMode="multiple"
                            selection={this.state.selectionPrivilegesGroup}
                            onSelectionChange={(selection) => {
                                selection.value = selection.value.filter(privilege => this.props.userPrivilegesLookup.includes(privilege.grant_privilege_token)).map((privilege) => privilege.id);
                                this.setState({selectionPrivilegesGroup: selection.value});
                            }}
                            rowClassName={(rowData) => {
                                const classes = {};
                                if (rowData.disabled) {
                                    classes["p-disabled"] = true;
                                }
                                return classes;
                            }}
                        />
                    </div>
                </div>
            </Fragment>);
    }
}

export default connect((state) => {
    return {
        userPrivilegesLookup: state.app.user.privileges.map(privilege => privilege.name)
    };
},{showModal})(createEditor({
    componentName: "Group",
    WrappedComponent: GroupPrivileges,
}));